import React from "react";
import * as colors from "../helpers/constants/colors";

const DEFAULT_STYLING = {
    backgroundColor: colors.typography,
    color: colors.white,
    borderRadius: "0px 10px 0px 10px",
    textAlign: "center",
    display: "inline-block",
    bottom: 0,
    padding: "3px 5px",
    cursor: "default",
    margin: "0% 1%",
    width: "100px"
};

export default ({ label, className, borderRadius, color, style, height }) => (
    <div
        className={className || ""}
        style={{
            ...DEFAULT_STYLING,
            ...(style || {}),
            ...{
                backgroundColor: color,
                height: height || "20px",
                display: "flex",
                flexOrientation: "column",
                borderRadius: `0px ${borderRadius || 10}px 0px ${borderRadius ||
                    10}px`
            }
        }}
    >
        <h5
            style={{
                margin: "auto"
            }}
        >
            {label || ""}
        </h5>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/ToothpasteTag.js